import { createAsyncThunk } from '@reduxjs/toolkit';
import { http } from '../../../helpers/request';

const LIVE_GUIDELINE_PRODUCT_TAGS_TTL_MS = 10 * 1000; // 10 seconds

type StateWithLiveGuidelineProductTagReducer = {
    liveGuidelineProductTagReducer: {
        byLiveGuidelineProductId: Record<number, { fetchedAt?: number }>;
    };
};

const baseUrl = '/LiveGuidelineProductTags';

export const getLiveGuidelineProductTagsByLiveGuidelineProductIdAction = createAsyncThunk<
    any,
    number,
    { state: StateWithLiveGuidelineProductTagReducer }
>(
    'liveGuidelineProductTags/getByLiveGuidelineProduct',
    async (liveGuidelineProductId: number) => {
        const result = await http<any, undefined>({
            path: `${baseUrl}/live-guideline-product/${liveGuidelineProductId}`,
            method: 'get',
        });
        const data = result.parsedBody?.data ?? result.parsedBody ?? [];
        return { liveGuidelineProductId, tags: data };
    },
    {
        condition: (liveGuidelineProductId, { getState }) => {
            const entry =
                getState().liveGuidelineProductTagReducer.byLiveGuidelineProductId[
                    liveGuidelineProductId
                ];
            if (
                entry?.fetchedAt &&
                Date.now() - entry.fetchedAt < LIVE_GUIDELINE_PRODUCT_TAGS_TTL_MS
            ) {
                return false;
            }
            return true;
        },
    },
);

export const getLiveGuidelineProductTagsByLiveGuidelineProductIdsAction = createAsyncThunk<
    any,
    number[]
>('liveGuidelineProductTags/getByLiveGuidelineProducts', async (liveGuidelineProductIds: number[]) => {
    const query = liveGuidelineProductIds.map((id) => `ids=${id}`).join('&');
    const result = await http<any, undefined>({
        path: `${baseUrl}/live-guideline-products?${query}`,
        method: 'get',
    });
    return result.parsedBody?.data ?? result.parsedBody ?? [];
});

export const createLiveGuidelineProductTagAction = createAsyncThunk<
    any,
    { liveGuidelineProductId: number; tagId: number }
>('liveGuidelineProductTags/create', async ({ liveGuidelineProductId, tagId }) => {
    const result = await http<any, { liveGuidelineProductId: number; tagId: number }>({
        path: `${baseUrl}`,
        method: 'post',
        body: { liveGuidelineProductId, tagId },
    });
    const created = result.parsedBody?.data ?? result.parsedBody;
    return { liveGuidelineProductId, created };
});

export const deleteLiveGuidelineProductTagAction = createAsyncThunk<any, number>(
    'liveGuidelineProductTags/delete',
    async (id: number) => {
        await http<any, number>({
            path: `${baseUrl}/${id}`,
            method: 'delete',
        });
        return { id };
    },
);
